export default __webpack_public_path__ + "static/media/3-HitpointCalculator-content.683bb6a3.md";